export default __webpack_public_path__ + "static/media/m_wdt_c_7.782a491c.mp3";